import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { CLINIC } from "../../data/content";
import LeadForm from "../site/LeadForm";

export default function FinalCTA() {
  return (
    <section className="bg-brand-blue-dark text-brand-cream">
      <div className="container-wide py-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="eyebrow text-brand-amber mb-3">Your next step</div>
          <h2 className="text-3xl md:text-5xl font-heading leading-[1.05] text-white">
            Your next step towards better movement can start here.
          </h2>
          <p className="mt-5 text-brand-cream/80 max-w-xl">
            Whether you're recovering from an injury or surgery, returning to sport, or working towards greater independence after a neurological condition — the first step is understanding where you are now and where you want to go.
          </p>
          <div className="mt-6 flex gap-3 flex-wrap">
            <Link to="/book" className="btn-accent" data-testid="footer-cta-book">
              Book Your Assessment <ArrowRight size={16} />
            </Link>
            <a
              href={`https://wa.me/${CLINIC.whatsapp}`}
              target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-medium text-white hover:bg-white/10 transition-colors"
            >
              <MessageCircle size={16} /> WhatsApp Physio Hyve
            </a>
          </div>
        </div>
        <div>
          <LeadForm sourcePage="home-footer-cta" category="general" />
        </div>
      </div>
    </section>
  );
}
